export default __webpack_public_path__ + "static/media/wayaPos.1f7c27b1.png";